/**
 * Query keys do domínio tournaments (apps/crm + apps/public).
 */
import { tuple } from "./core";

const root = ["tournaments"] as const;

const finance = {
  /**
   * Invalida sponsors+expenses+revenues de um torneio (prefix-match).
   * Estrutura: ['tournaments','finance', id, '<sub>'] — id ANTES do sub-name
   * para que `all(id)` seja prefix válido das sub-keys (sponsors/expenses/revenues).
   * Sem id: `['tournaments','finance']` invalida o domínio finance inteiro.
   */
  all: (tournamentId?: string | null) =>
    tournamentId == null
      ? tuple(root, "finance")
      : tuple(root, "finance", tournamentId),
  sponsors: (tournamentId: string | null | undefined) =>
    tuple(root, "finance", tournamentId, "sponsors"),
  expenses: (tournamentId: string | null | undefined) =>
    tuple(root, "finance", tournamentId, "expenses"),
  revenues: (tournamentId: string | null | undefined) =>
    tuple(root, "finance", tournamentId, "revenues"),
} as const;

export const tournaments = {
  all: root,
  byClub: (clubId: string | null | undefined) =>
    tuple(root, "by-club", clubId),
  byId: (tournamentId: string | null | undefined) =>
    tuple(root, "detail", tournamentId),
  finance,
  // Wave 1 (tournaments packages extract) — spec §3.5.
  /** Sessão live-match individual (por match_id). */
  liveMatch: (matchId: string | null | undefined) =>
    tuple(root, "live-match", matchId),
  /** Todas live-match sessions de um torneio. */
  liveMatchByTournament: (tournamentId: string | null | undefined) =>
    tuple(root, "live-match", "by-tournament", tournamentId),
  /** Bracket completo de um torneio (matches gerados). */
  bracket: (tournamentId: string | null | undefined) =>
    tuple(root, "bracket", tournamentId),
  /**
   * Head-to-head entre 2 jogadores. IDs ordenados deterministicamente
   * (sort + join ':') para que (a,b) e (b,a) produzam mesma key.
   */
  h2h: (playerAId: string | null | undefined, playerBId: string | null | undefined) =>
    tuple(
      root,
      "h2h",
      [playerAId ?? "", playerBId ?? ""].sort().join(":"),
    ),
  /** Últimas partidas de um jogador. */
  playerRecentMatches: (playerId: string | null | undefined) =>
    tuple(root, "recent", playerId),
  /** View TV de um torneio (Torneio.tsx /tv). */
  tv: (tournamentId: string | null | undefined) => tuple(root, "tv", tournamentId),
} as const;
